import generateSessiondIdIfNotExists from './generate-sessionid.js';
import getLanguage from './get-language.js';

(async () => {
    const whatsappOptin = document.getElementById('whatsappOptin');
    if(whatsappOptin) {
        const { lang } = getLanguage()
        const whatsappOptinLoader = whatsappOptin.querySelector('#whatsappOptinLoader')
        // const whatsappSignupContainer = whatsappOptin.querySelector('#whatsappSignupContainer')
        const whatsappPhoneEL = whatsappOptin.querySelector('#whatsapp-phone')
        
        // Query params 
        let countryCode = getUrlParameter('countryCode')
        let token =getUrlParameter('token') || ''
        const receiverCountry = getUrlParameter('receiverCountry')?.toUpperCase()
        const customerID = getUrlParameter('customerID')
        let sessionId = getUrlParameter('sessionId')
        const PayIN = getUrlParameter('PayIN')
        const PayOut = getUrlParameter('PayOut')
        const mtcn =  getUrlParameter('mtcn')  || getUrlParameter('MTCN')
        const externalRefId = getUrlParameter('id')
        const givenName = getUrlParameter('givenName')
        const surname1 = getUrlParameter('surname1')
        const surname2 = getUrlParameter('surname2')
        const phone = getUrlParameter('phone')
        if(countryCode && countryCode.startsWith('+') && countryCode.length > 0) {
            countryCode = countryCode.replace('+','')
        }
        token = token?.startsWith('Bearer') ? token : `Bearer ${token}`

        const whatsappNumberErrorSuccess = whatsappOptin.querySelector('#whatsappNumberErrorSuccess')
        const successSection = whatsappNumberErrorSuccess.querySelector('.success')
        const countdownEl = successSection.querySelector('#countdown')
        const errorSection = whatsappNumberErrorSuccess.querySelector('.error')
        const saveAddBank = whatsappOptin.querySelector('#save-add-bank')
        // const whatsappSuccessErrorText = whatsappOptin.querySelector('#whatsappSuccessErrorText')
        
        sessionId = await generateSessiondIdIfNotExists(sessionId, receiverCountry, lang)

        const hideWhatsappOptinLoader = () => {
            toggleClass(whatsappOptinLoader, 'd-flex', 'd-none');
        }

        const showSuccessScreen = (errorScenario) => {
            let countdownEl;
            if(errorScenario) {
                toggleClass(errorSection, 'd-none', 'd-flex')
                countdownEl = whatsappOptin.querySelector('.countdown.error-case')
            } else {
                toggleClass(successSection, 'd-none', 'd-flex')
                countdownEl = whatsappOptin.querySelector('.countdown.success-case')
            }
            toggleClass(whatsappNumberErrorSuccess, 'd-none', 'd-flex');
            
            let counter = 5
            countdownEl.innerText = counter--
            const inerval = setInterval(() => {
                countdownEl.innerText = counter--
                if(counter === 0) {
                    location.href = `https://wa.me`
                }
            },1000)
        }

        const customerRequestBody = {
            customer: {
              name: {
                givenName: givenName,
                paternal: surname1,
                maternal: surname2 || "",
                nameType: "M"
              },
              
              notification: {
                optInWhatsApp: true,
                prefLanguageCode: lang,
              },
            
            },
          };
   
    const triggerUpdateCustomer = async()=>{
        console.log("in update")
        sessionId = await generateSessiondIdIfNotExists(
          sessionId,
          receiverCountry,
          lang
        );
  
  
        const customerHeaders = {
          "Content-Type": `application/json`,
          "x-wu-correlationId": `web-` + generateUniqueID(),
          "x-wu-externalRefId": externalRefId || `web-` + generateUniqueID(),
          "x-wu-accountNumber": customerID,
          "x-wu-countryCode": receiverCountry,
          "applicationSource": "WHATSAPP",
          "x-wu-sessionId": sessionId,
          "x-wu-redirect-mtcn": mtcn,
          "Authorization": `${token}`,
        };
  
        if (customerRequestBody.customer.email)
          delete customerRequestBody.customer.email;
  
        if (customerRequestBody.customer.credential.password)
          delete customerRequestBody.customer.credential.password
  
  
        const requestOptions = {
          method: "PUT",
          headers: customerHeaders,
          body: JSON.stringify(customerRequestBody)
        };
        try {
          const customerData = await fetchApiWu(
            `/cusprofile/v2/cust/customers/update`,
            requestOptions,
            "customer"
          );
          if (customerData?.customer) {
            // paymentExists = !!(
            //   customerData?.customer?.payment?.banks ||
            //   customerData?.customer?.payment?.cards ||
            //   customerData?.customer?.payment?.wallets
            // );
            hidefullRegistrationLoader();
          } else {
            //showErrorOrThanxScreen({ ok: false, wrongParams: true });
            showSuccessScreen(true);
          }
        } catch (e) {
          //showErrorOrThanxScreen({ ok: false, wrongParams: true });
          showSuccessScreen(true);
        }
      };
  

        // saveAddBank.addEventListener('click',(e) => triggerAddWhatsAppPhone())

        // if(token && receiverCountry ) {
        //     hideWhatsappOptinLoader()
        //     showSuccessScreen(true)
        // }
        if (token && receiverCountry && customerID) {
          triggerUpdateCustomer();
        } else {
          hideWhatsappOptinLoader();
          showSuccessScreen(true);
        }
    }
})()